import header from 'i18n/default/fr/header';
import mainMenu from 'i18n/default/fr/mainMenu';
import pendingPaymentAdvice from 'i18n/default/fr/pendingPaymentAdvice';
import PalletType from 'i18n/default/fr/PalletType';
import LiteralCurrency from 'i18n/default/fr/LiteralCurrency';
import units from 'i18n/default/fr/units';
import CustomPalletSize from 'i18n/default/fr/CustomPalletSize';
import NumberOfItems from 'i18n/default/fr/NumberOfItems';
import LoadInfo from 'i18n/default/fr/LoadInfo';
import LoadInputs from 'i18n/default/fr/LoadInputs.json';
import dates from 'i18n/default/fr/dates';
import AddressFormModal from 'i18n/default/fr/AddressFormModal';
import Addresses from 'i18n/default/fr/Addresses';
import AddressSelector from 'i18n/default/fr/AddressSelector';
import StopAddress from 'i18n/default/fr/StopAddress';
import Quote from 'i18n/default/fr/Quote';
import extraNames from 'i18n/default/fr/extraNames';
import timePickers from 'i18n/default/fr/timePickers';
import authLoginForm from 'i18n/default/fr/authLoginForm';
import authSignUpForm from 'i18n/default/fr/authSignUpForm';
import HandlingExtra from 'i18n/default/fr/HandlingExtra';
import Stop from 'i18n/default/fr/Stop';
import VehicleExtras from 'i18n/default/fr/VehicleExtras';
import OrderStop from 'i18n/default/fr/OrderStop';
import ShipmentCard from 'i18n/default/fr/ShipmentCard';
import Orders from 'i18n/default/fr/Orders';
import Summary from 'i18n/default/fr/Summary';
import Login from 'i18n/default/fr/Login';
import AddressesPage from 'i18n/default/fr/AddressesPage';
import ModalSummary from 'i18n/default/fr/ModalSummary';
import OrderSummary from 'i18n/default/fr/OrderSummary';
import OrdersOrderDetail from 'i18n/default/fr/OrdersOrderDetail';
import ModalOrderDetail from 'i18n/default/fr/ModalOrderDetail';
import loads from 'i18n/default/fr/loads';
import SuggestedTimes from 'i18n/default/fr/SuggestedTimes';
import Downloads from 'i18n/default/fr/Downloads';
import CreditCard from 'i18n/default/fr/CreditCard';
import TypeOfOrderSelector from 'i18n/default/fr/TypeOfOrderSelector';
import Recurring from 'i18n/default/fr/Recurring';
import Settings from 'i18n/default/fr/Settings';
import InviteUserModal from 'i18n/default/fr/InviteUserModal';
import PaymentData from 'i18n/default/fr/PaymentData';
import DriverMapError from 'i18n/default/fr/DriverMapError';
import Faqs from 'i18n/default/fr/Faqs';
import AdditionalDocuments from 'i18n/default/fr/AdditionalDocuments';
import Communications from 'i18n/default/fr/Communications';
import RecurringOrderSuggestions from 'i18n/default/fr/RecurringOrderSuggestions';
import Error from 'i18n/default/fr/Error';
import Users from 'i18n/default/fr/Users';
import Tracking from 'i18n/default/fr/Tracking';
import Dashboard from 'i18n/default/fr/Dashboard';
import Catalog from 'i18n/default/fr/Catalog';
import SignUp from 'i18n/default/fr/SignUp';
import Emergencies from 'i18n/default/fr/Emergencies';
import Profile from 'i18n/default/fr/Profile';
import Landing from 'i18n/default/fr/Landing';

const lang = {
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  ModalSummary,
  OrderSummary,
  OrdersOrderDetail,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Dashboard,
  SignUp,
  Emergencies,
  Profile,
  Landing
};

export default lang;
